import React, {useEffect, useState} from 'react';
import './TableProfitReport.scss';
import {formatToPersianAddCommaNegativeToParentheses} from "../../../../utils/CommaSeparator";
import NumericFunction from "../../../../utils/NumericFunction";

const TableProfitReport = ({column, data, priceFields}) => {

  const [fieldColumn, setFieldColumn] = useState([]);
  const [numberColumn, setNumberColumn] = useState([])

  useEffect(() => {
    let temp = []
    column.forEach((myColumn) => {
      if (myColumn.headerFilter) {
        temp.push(myColumn.field);
      }
    })
    setFieldColumn(temp)

    if (priceFields !== undefined) {
      setNumberColumn([...priceFields]);
    }
  }, [column]);

  try {
    return (
      <div className={"TableProfitReport"}>
        <h6>{data?.caption}</h6>

        <ul className={"main-table-profit-report"}>
          <li className="header-table">
            {column?.map((v, index) => (
              <>
                {v.headerFilter && (
                  <span key={"R" + index} className={"table-cell"}>
                  {v.title}
                </span>
                )}
              </>
            ))}
          </li>
          {data?.data.length > 0 && data?.data.map((item, index) =>
            <li key={"R" + index} className={"middle-table"}>
              {fieldColumn.map((field, indexField: number) => {
                return (
                  <span key={indexField} className={"table-cell"}>
                  {numberColumn.includes(field) ? (
                    formatToPersianAddCommaNegativeToParentheses(item[field])
                  ) : (
                    NumericFunction.e2p(item[field])
                  )}
                </span>
                );
              })}
            </li>
          )}
          <li className="header-table">
            <span>{"جمع " + " " + data?.caption}</span>
            <span>
              {formatToPersianAddCommaNegativeToParentheses(data?.data.reduce((sum, item) => sum + +item.totalRemaining, 0))}
            </span>
          </li>
        </ul>

      </div>
    );
  } catch (e) {
    return <>{e.toString()}</>
  }
};

export default TableProfitReport;